namespace Solovis.UI {

    /*
     * options:
     *      itemElementContentGetter: function (item) that returns jQuery or dom element for item content.
     */
    export class SmallOrderedListBuilder extends Solovis.UI.BaseControl {

        public _idGetter;
        public _labelGetter;
        public _itemElementContentGetter;
        public currentItemIds;
        public idToItemMap;
        public currentItemListDiv: JQuery;
        public addItemDiv: JQuery;
        public addItemLink: JQuery;


        constructor(options) {
            super(options);

            this.transition = Solovis.UI.ControlHost.Transitions.None;

            var self = this;

            this._idGetter = function (item) { return item.id; };
            this._labelGetter = function (item) { return item.label; };

            if (options.itemElementContentGetter) {
                this._itemElementContentGetter = options.itemElementContentGetter;
            }
            else {
                this._itemElementContentGetter = function (item) {
                    var label = self._labelGetter(item);
                    return label;
                };
            }

            this.currentItemIds = options.currentItemIds ? options.currentItemIds : [];

            var allItems = options.allItems ? options.allItems : [];
            this.updateAllItems(allItems);
        }

        public doInit() {
        }

        public doRender() {
            var self = this;

            this.container.html("");

            this.currentItemListDiv = $("<ul>").addClass("small-ordered-list-builder").appendTo(this.container);

            $(this.currentItemIds).each(function (i, itemId: any) {
                if (self.idToItemMap[itemId]) {
                    var item = self.idToItemMap[itemId];

                    var itemElement = self._createActiveItemElement(item);
                    itemElement.appendTo(self.currentItemListDiv);
                }
            });

            (this.currentItemListDiv as any).sortable({
                update: function (event, ui) {
                    self._notifyItemsChanged();
                }
            });

            this.addItemDiv = $("<div>")
                .addClass("small-ordered-list-builder-add-item")
                .appendTo(this.container);

            this.addItemLink = $("<a>")
                .click(function () {
                    self.showAddItemInterface();
                })
                .html("<span style='position: relative; top: 1px; margin: 0; padding: 0' class='ui-icon ui-icon-plus'></span>")
                .appendTo(this.addItemDiv);

            this._updateAddItemDivVisibility();
        };

        public _createActiveItemElement = function (item) {
            var self = this;

            var id = this._idGetter(item);

            var itemContent = this._itemElementContentGetter(item);
            var itemElement = $("<li>").append(itemContent);
            itemElement.data("itemId", id);

            var removeItem = $("<a>")
                .html("<span style='position: relative; top: 2px; margin: 0; padding: 0' class='ui-icon ui-icon-close'></span>")
                .click(function () {
                    self.removeItem(id);
                })
                .appendTo(itemElement);

            return itemElement;
        };

        public _updateAddItemDivVisibility = function () {
            var self = this;

            var currentItems = this.getCurrentItems();
            var currentItemIdMap = {};
            $(currentItems).each(function (i, item) {
                var itemId = self._idGetter(item);
                currentItemIdMap[itemId] = true;
            });

            var unaddedItemFound = false;

            $(this.allItems).each(function (i, item) {
                var itemId = self._idGetter(item);
                if (!currentItemIdMap[itemId]) {
                    unaddedItemFound = true;
                }
            });

            if (unaddedItemFound) {
                this.addItemDiv.toggle(true);
            }
            else {
                this.addItemDiv.toggle(false);
            }
        };

        public updateAllItems = function (newItemList) {
            var self = this;

            if (!newItemList) {
                newItemList = [];
            }

            var newIdToItemMap = {};
            $(newItemList).each(function (i, item) {
                newIdToItemMap[self._idGetter(item)] = item;
            });

            this.allItems = newItemList;
            this.idToItemMap = newIdToItemMap;

            if (this.currentItemIds) {
                // Filter out any ids that do exist in item map.
                this.currentItemIds = _.filter(
                    this.currentItemIds,
                    function (itemId: any) {
                        return (typeof self.idToItemMap[itemId] != "undefined");
                    });
            }

            if (this.currentItemListDiv) {
                // Filter out any active item ids that do not exist in new item set.
                var alreadyExists = false;

                this.currentItemListDiv.children("li").each(function (i, itemDiv) {
                    var itemIdForDiv = $(itemDiv).data("itemId");
                    if (typeof self.idToItemMap[itemIdForDiv] == "undefined") {
                        itemDiv.remove();
                    }
                });
            }
        };

        public addItem = function (itemId) {
            var self = this;

            if (this.currentItemListDiv) {
                var alreadyExists = false;

                this.currentItemListDiv.children("li").each(function (i, itemDiv) {
                    var itemIdForDiv = $(itemDiv).data("itemId");
                    if (itemIdForDiv == itemId) {
                        alreadyExists = true;
                    }
                });

                if (!alreadyExists) {
                    if (self.idToItemMap[itemId]) {
                        var item = self.idToItemMap[itemId];

                        var itemElement = self._createActiveItemElement(item);
                        itemElement.appendTo(self.currentItemListDiv);
                    }
                }

                this._notifyItemsChanged();
            }

            this._updateAddItemDivVisibility();
        };

        public removeItem = function (itemId) {
            var self = this;

            if (this.currentItemListDiv) {
                this.currentItemListDiv.children("li").each(function (i, itemDiv) {
                    var itemIdForDiv = $(itemDiv).data("itemId");
                    if (itemIdForDiv == itemId) {
                        $(itemDiv).remove();
                    }
                });

                this._notifyItemsChanged();
            }

            this._updateAddItemDivVisibility();
        };

        public getCurrentItems = function () {
            var self = this;
            var currentItems = [];

            if (this.currentItemListDiv) {
                this.currentItemListDiv.children("li").each(function (i, itemDiv) {
                    var itemId = $(itemDiv).data("itemId");
                    if (self.idToItemMap[itemId]) {
                        var item = self.idToItemMap[itemId];
                        currentItems.push(item);
                    }
                });
            }
            else {
                $(this.currentItemIds).each(function (i, itemId: any) {
                    if (self.idToItemMap[itemId]) {
                        var item = self.idToItemMap[itemId];
                        currentItems.push(item);
                    }
                });
            }

            return currentItems;
        };

        public _notifyItemsChanged = function () {
            $(this).trigger("itemsChanged");
        };


        public showAddItemInterface = function () {
            var self = this;

            var currentItems = this.getCurrentItems();
            var currentItemIdMap = {};
            $(currentItems).each(function (i, item) {
                var itemId = self._idGetter(item);
                currentItemIdMap[itemId] = true;
            });

            var links = [];

            $(this.allItems).each(function (i, item) {
                var itemId = self._idGetter(item);

                if (!currentItemIdMap[itemId]) {
                    var label = self._labelGetter(item);

                    links.push({
                        label: label,
                        click: function () {
                            self.addItem(itemId);
                        }
                    });
                }
            });

            Solovis.UI.PopupLinkPanel.showLinks({
                useLegacyPanel: true,
                offsetElement: this.addItemDiv,
                links: links
            });
        };
    }

}

